import React, { useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import * as state from '@/state';
import { DeckPlanExplorer } from './DeckPlanExplorer';
import { DeckPlanDataLoader } from './DeckPlanDataLoader';
import { selectedStructureId } from '@/state';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { Snackbar } from '@/components/shared/Snackbar';
import { AccessGuard } from '@/components/Analysis/shared/AccessGuard';
import { EchoChat } from '@/components/shared/EchoChat';

export const DeckPlan = ({ inspectionId }: { inspectionId: string }) => {
  const [snackbarMessage, setSnackbarMessage] = useAtom(state.snackbarMessage);
  const setSelectedStructureId = useSetAtom(selectedStructureId);

  useEffect(() => {
    setSelectedStructureId(inspectionId);
  }, [setSelectedStructureId, inspectionId]);

  const closeSnack = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarMessage({ shouldShow: false, content: undefined });
  };

  const { shouldShow, content } = snackbarMessage;

  return (
    <StructureCheck structureId={inspectionId}>
      <AccessGuard structureId={inspectionId} feature="deckPlan">
        <DeckPlanDataLoader>
          <Snackbar open={shouldShow} onClose={closeSnack}>
            {content}
          </Snackbar>
          <DeckPlanExplorer />
          <EchoChat />
        </DeckPlanDataLoader>
      </AccessGuard>
    </StructureCheck>
  );
};
